// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2tL00","upload":"Small_upload__3Lgze","imageWrap":"Small_imageWrap__2aQ8M","removeBtn":"Small_removeBtn__1UpTk"};